import { OMS_GUEST_ORDER_TRACKING_PATH } from '../../constants/paths';
import { apiB2B } from '../axios-client';
export var getGuestOrderTracking = function (requestData) {
    return apiB2B.post(OMS_GUEST_ORDER_TRACKING_PATH, requestData);
};
